import styled from 'styled-components';

export const StyledGenderPicker = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  gap: 10px;
`;

export const StyledGender = styled.div<{ status: string; isActive: boolean }>`
  height: 100%;
  flex: 1;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xxxl};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme, status, isActive }): string =>
    isActive
      ? status === 'Male'
        ? theme.colors.male
        : theme.colors.female
      : theme.colors.minorText};
  font-size: ${({ theme }): string => theme.fontSizes[6]};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
  padding: 0 5px;
  cursor: pointer;
`;

export const StyledIconContainer = styled.div<{
  status: string;
  isActive: boolean;
}>`
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }): string => theme.radii.full};
  color: ${({ theme }): string => theme.colors.secondaryButtonText};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, status, isActive }): string =>
    isActive
      ? status === 'Male'
        ? theme.colors.male
        : theme.colors.female
      : theme.colors.minorText};
`;

export const StyledTitle = styled.div`
  display: flex;
  justify-content: center;
  flex: 3;
  margin-left: 20px;
`;
